import { Component, HostListener, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ChaseError } from '@app/interfaces/payment-tech.interface';
// import { IconDefinition, faCreditCard } from '@fortawesome/free-solid-svg-icons';
// import { Policy } from "@app/interfaces/policy.interface";
import { BillingStoreService } from '../store/billing-store.service';
import { PayerInfoService } from './payer-info.service';
import { BillingStore } from '@app/interfaces/billing-store.interface';
import { environment } from '../../../environments/environment';
import { constants } from './../../@shared/constants';
import { ThemingService } from '@shared/services/theming.service';
import { Theme } from '@shared/themes/default.theme';
import { AptFeatureFlagService } from '@archinsurance-da/arch-portal-tools';
import { PendoService } from '@app/@shared/services/pendo/pendo.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SavedPaymentMethodService } from '@shared/services/saved-payment-method.service';
import { BillingInfoService, SavedCardProfile } from '@shared/services/billing-info.service';
const DEFAULT_PRODUCT = 'essentialpl';

@Component({
  selector: 'app-payer-info',
  templateUrl: './payer-info.component.html',
  styleUrls: ['./payer-info.component.scss'],
  standalone: false,
})
export class PayerInfoComponent implements OnInit {
  // -- TEST VISA CARD: 4788250000028291
  TESTINGPAYMENTUS: boolean = false;
  cyberOfferEnabled: boolean = false;
  chaseUID: string = '';
  paymentUsToken: string = '';
  theme: Theme;
  BYPASSBINDCALL: boolean = true;
  requestSent: boolean = false;
  iframeSrc: string = '';
  policyStore: BillingStore = {};
  addressString: string = '';
  errors: ChaseError[] = [];
  isCyberFlow: boolean = false;
  useSavedPaymentMethod: boolean = true;
  savedPaymentProfile: SavedCardProfile | null = null;
  loadingSavedPaymentProfile: boolean = false;
  //SIMULATE_POSTPAYMENT: boolean = false;
  processingPayment: boolean = false;
  coverageLiteralName: string;
  show_chaseFormOnly: boolean = false; //environment.envName.toLowerCase() == 'dev';
  chaseFormOnly: boolean = false; //environment.envName.toLowerCase() == 'dev';
  displayUID: string;
  displayToken: string;
  paramProduct: any;
  contactNumber: string;
  //safeSrc: SafeResourceUrl;
  iframeHeight: string = '100%';
  paymentUsSrc: string;

  constructor(
    private router: Router,
    private billingInfoService: BillingInfoService,
    private payerInfoService: PayerInfoService,
    private billingStoreService: BillingStoreService,
    private route: ActivatedRoute,
    private themeService: ThemingService,
    private pendoService: PendoService,
    private ffService: AptFeatureFlagService,
    private savedPaymentMethodService: SavedPaymentMethodService
  ) {
    if (environment.paymentUsOrigin) {
      //console.log('envvv', environment.paymentUsOrigin);
      //chase sends alerts manually, override alerts from chase
      window.alert = function () {};
    }
  }

  producer: string = ''; //default nationwide
  setProducer(overrideProducerId?: string) {
    if (!/^P/.test(overrideProducerId) && overrideProducerId !== 'generic' && overrideProducerId !== 'auto') {
      overrideProducerId = `P${overrideProducerId}`;
    }

    // console.log('overrideProducerId', overrideProducerId);

    if (overrideProducerId && overrideProducerId != 'default') {
      this.producer = overrideProducerId;
    } else {
      this.producer = 'P43274'; //TODO: NEED TO GET FROM POLICY RESPONSE
    }

    if (overrideProducerId === 'generic') {
      this.themeService.setTheme('generic');
    } else {
      if (this.paramProduct == 'ea') {
        this.producer = 'P43580'; //Canopy
      }

      if (constants.producerIds.hasOwnProperty(this.producer) && constants.producerIds[this.producer].theme) {
        this.themeService.setTheme(constants.producerIds[this.producer].theme);
      } else if (!this.producer) {
        this.themeService.setTheme('generic');
      }
    }
  }
  //repsonsive script load from Dale clear
  private loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }
  private setPaymentUsUrl() {
    this.paymentUsSrc = `${environment.paymentUsIframe}`;
    // console.log('this.payment', this.paymentUsSrc);

    // this.loadScript(
    //   `${environment.chaseOrigin[`version${this.chase_version}`].origin}${
    //     constants.chase[`version${this.chase_version}`].jsPath
    //   }`
    // );
  }

  // private setChaseVersion(chase_version: number) {
  //   this.chase_version = chase_version;

  //   this.chaseSrc = `${environment.chaseOrigin[`version${this.chase_version}`].iframeOrigin}${
  //     constants.chase[`version${chase_version}`].iframePath
  //   }`;

  //   this.loadScript(
  //     `${environment.chaseOrigin[`version${this.chase_version}`].origin}${
  //       constants.chase[`version${this.chase_version}`].jsPath
  //     }`
  //   );
  // }

  ngOnInit(): void {
    // this.themeService.setTheme('');
    this.themeService.themeChange.subscribe((theme: Theme) => {
      this.theme = theme;
      console.log('this.theme.name', this.theme.name);
    });

    this.ffService.flagChange.subscribe((flags: any) => {
      const enterCustomUID = !flags.enterCustomUID?.current ? flags.enterCustomUID : flags.enterCustomUID.current;
      const cyberOfferEnabled = !flags.cyberOfferEnabledAgent?.current
        ? flags.cyberOfferEnabledAgent
        : flags.cyberOfferEnabledAgent.current;
      // console.log('flags', flags);

      this.TESTINGPAYMENTUS = enterCustomUID;
      this.cyberOfferEnabled = cyberOfferEnabled;
    });

    this.policyStore = this.billingStoreService.getBillingStore();

    this.setProducer(this.policyStore.policyData.responseJSON.policy.agentCd);

    if (!this.policyStore) {
      this.router.navigate(['policy']);
    }
    // console.log('this.policyStore', this.policyStore);
    this.setPaymentUsUrl();
    const product = this.policyStore.product;
    this.paramProduct = product == 'ea' ? product : DEFAULT_PRODUCT;

    if (this.paramProduct == 'ea') {
      this.theme.agent.phone = constants.contactForCanopy;
      this.themeService.setTheme(this.theme);
    }

    this.addressString = `${this.policyStore.policyData.policy.addressDto.insuredAddressStreetLine1Txt}, ${this.policyStore.policyData.policy.addressDto.insuredAddressCityTxt}, ${this.policyStore.policyData.policy.addressDto.insuredAddressStateCd} ${this.policyStore.policyData.policy.addressDto.insuredAddressPostalCd}`;

    this.isCyberFlow = this.getIsCyberFlowFromPolicy();
    this.billingStoreService.setCyberFlag(this.isCyberFlow ? 'Y' : 'N');
    this.loadSavedPaymentProfile();
    if (!this.isCyberFlow && this.policyStore?.policyData?.policy?.quoteCoverageList) {
      this.coverageLiteralName =
        this.policyStore?.policyData?.policy?.quoteCoverageList[0].coverageCodeInfo.coverageLiteralName.replace(
          'Miscellaneous/Specified',
          'Miscellaneous'
        );
    }

    if (this.policyStore?.policyData?.referenceData?.product?.productOffering) {
      const productMapping: { [index: string]: any } = {
        PRDCNP: 'Management Liability', //'Arch Corporate Canopy Policy Private Company Management Liability & Crime Insurance',
        MSPPL: 'Miscellaneous/Specified Professional Liability',
        MSSPL: 'Miscellaneous/Specified Professional Liability',
        NPL: 'Cyber',
      };
      let productOffering = this.policyStore.policyData.referenceData.product.productOffering;
      // console.log('productOffering', productOffering);
      this.coverageLiteralName = productMapping[productOffering] ? productMapping[productOffering] : productOffering;
    }

    // if (this.chaseUID) {
    //hosted_tokenize=store_authorize
    //  this.updateChaseIframe(this.chaseUID);
    // } else {
    // this.payerInfoService.getPaymentTechUID(this.policyStore).subscribe((data: any) => {
    // console.log('getPaymentTechUID data', data);
    //call iframe service
    // console.log('data', data);
    //     this.updateChaseIframe(data.uID);
    //   });
    // }

    if (this.paymentUsToken) {
      this.updatePaymentUsIframe(this.paymentUsToken);
    } else {
      this.payerInfoService.getPaymentUsToken(this.policyStore).subscribe((data: any) => {
        // console.log('dataPaymentUs', data.token);
        this.updatePaymentUsIframe(data.token);
      });
    }
  }

  //updateChaseIframe(chaseUid: string) {
  // console.log('chaseUid', chaseUid);
  //this.displayUID = chaseUid;

  //this.iframeSrc = `${this.chaseSrc}${chaseUid}`;

  //  console.log('this.iframeSrc', this.iframeSrc);
  //}
  updatePaymentUsIframe(paymentUsToken: string) {
    // console.log('paymentUsToken', paymentUsToken);
    this.displayToken = paymentUsToken;
    this.iframeSrc = `${this.paymentUsSrc}${this.displayToken}`;
    // console.log('this.iframeSrcPayment', this.iframeSrc);
  }

  goToPolicy() {
    this.router.navigate(['policy', this.policyStore.policyData.policy.policyId]);
  }

  processPayMessages: string[] = [
    'Thank you for your request.',
    'Validating your payment.',
    'Issuing the policy.',
    'Updating and synchronizing our records.',
    'Saving updated information to your policy.',
    'Polishing up final details.',
    'Your time is very important to us.',
    'We should be finishing up shortly. Thank you for your patience.',
  ];
  savedPaymentLookupMessages: string[] = ['Checking for your saved payment method.'];
  processPayTimedOut: boolean = false;
  processPayTimeOutChange($event: any) {
    console.log('payment timed out $event', $event);
  }

  private getIsCyberFlowFromPolicy(): boolean {
    const policyOffering =
      this.policyStore?.policyData?.responseJSON?.policy?.productOffering ||
      this.policyStore?.policyData?.referenceData?.product?.productOffering;

    if (policyOffering) {
      return policyOffering === 'NPL';
    }

    return this.billingStoreService.isCyberFlow();
  }

  get showSavedPaymentOption(): boolean {
    return this.isCyberFlow && !!this.savedPaymentProfile?.token;
  }

  get showPaymentIframe(): boolean {
    return !!this.iframeSrc && (!this.showSavedPaymentOption || !this.useSavedPaymentMethod);
  }

  get savedPaymentLabel(): string {
    return `Use existing payment method (${this.getMaskedSavedCardNumber()})`;
  }

  payWithSavedPaymentMethod(): void {
    if (!this.showSavedPaymentOption) {
      return;
    }

    const savedPaymentMethod = this.savedPaymentMethodService.getSavedPaymentMethod();
    const mplPolicyId = savedPaymentMethod?.mplPolicyId;
    const cyberPolicyId = this.policyStore?.policyData?.policy?.policyId;

    if (!mplPolicyId || !cyberPolicyId) {
      this.errors.push({
        code: 'NA',
        message: 'Unable to use saved payment method. Please enter a new card.',
      });
      return;
    }

    this.processingPayment = true;
    this.billingInfoService
      .processSavedCard({
        mplPolicyId,
        cyberPolicyId,
        amount: this.getPaymentAmount(),
      })
      .subscribe(
        (response: any) => {
          this.handleAuthorizedPaymentResponse(response, this.savedPaymentProfile?.token);
        },
        (errorResponse: any) => {
          console.log('errorResponse', errorResponse);
          this.processingPayment = false;
          this.errors.push({
            code: 'NA',
            message: 'There was an unexpected error. Please contact Arch Service Center for support.',
          });
        }
      );
  }

  private loadSavedPaymentProfile(): void {
    if (!this.isCyberFlow) {
      return;
    }

    const savedPaymentMethod = this.savedPaymentMethodService.getSavedPaymentMethod();
    const mplPolicyId = savedPaymentMethod?.mplPolicyId;
    if (!mplPolicyId) {
      return;
    }

    this.loadingSavedPaymentProfile = true;
    this.billingInfoService.getSavedPaymentProfile(mplPolicyId).subscribe(
      (profile) => {
        if (profile?.token) {
          this.savedPaymentProfile = profile;
          this.useSavedPaymentMethod = true;
        }
        this.loadingSavedPaymentProfile = false;
      },
      () => {
        this.loadingSavedPaymentProfile = false;
      }
    );
  }

  private getMaskedSavedCardNumber(): string {
    const last4 = this.savedPaymentProfile?.cardNo;
    if (!last4) {
      return '****';
    }

    return `**** **** **** ${last4}`;
  }

  private getPaymentAmount(): number {
    const amount = Number(this.policyStore?.dueToday ?? this.policyStore?.total ?? 0);
    return Number(amount.toFixed(2));
  }

  private handleAuthorizedPaymentResponse(response: any, token: string): void {
    if (this.theme?.agent?.phone) {
      this.policyStore.policyData.responseJSON.policy.supportPhoneNo = this.theme.agent.phone;
    }

    const uid = response?.['payment-response']?.['reference-number'];
    if (response?.['payment-response']?.['payment-status'] === 'ACCEPTED' && uid && token) {
      sessionStorage.setItem('uidToken', JSON.stringify({ uid, token }));
      const existingSavedPayment = this.savedPaymentMethodService.getSavedPaymentMethod();
      if (existingSavedPayment?.paymentusResponse) {
        this.savedPaymentMethodService.setSavedPaymentMethod({
          mplPolicyId: this.policyStore?.policyData?.policy?.policyId,
          paymentusResponse: existingSavedPayment.paymentusResponse,
        });
      }

      this.completePostPaymentProcessing(uid, token);
      return;
    }

    this.processingPayment = false;
    this.errors.push({
      code: 'NA',
      message:
        response?.['payment-response']?.['payment-status-description'] ||
        'There was an unexpected error. Please contact Arch Service Center for support.',
    });
  }

  private completePostPaymentProcessing(uid: string, token: string): void {
    this.payerInfoService.doPostPaymentProcessing(uid, token, this.policyStore).subscribe(
      (response: any) => {
        this.processingPayment = false;
        if (response === true || response?.returnCode === 'SUCCESS') {
          sessionStorage.setItem('successPayData', JSON.stringify(response));

          if (this.policyStore.policyData.policy.renewalFlag && this.policyStore.policyData.policy.renewalFlag == 'Y') {
            this.router.navigate(['success']);
          } else {
            if (this.policyStore.redirectUrl && this.payerInfoService.validateUrl(atob(this.policyStore.redirectUrl))) {
              if (this.isCyberFlow) {
                location.href = this.payerInfoService.getRedirectUrlWithParams(this.policyStore);
                return;
              } else if (!this.cyberOfferEnabled) {
                location.href = this.payerInfoService.getRedirectUrlWithParams(this.policyStore);
                return;
              } else {
                this.router.navigate(['success']);
              }
            } else {
              this.router.navigate(['success']);
            }
          }
        }
      },
      (errorResponse: any) => {
        this.processingPayment = false;
        this.errors.push({
          code: 'NA',
          message: 'There was an unexpected error. Please contact Arch Service Center for support.',
        });
      }
    );
  }

  //Handle events coming from the payment iframe
  @HostListener('window:message', ['$event'])
  handlePostMessages($event: MessageEvent) {
    console.log('$event', $event);
    if ($event.origin === environment.paymentUsOrigin) {
      this.errors = [];
      let data = $event.data;
      let sender = $event.data.split(':');

      if (sender[0] == 'pmDetails') {
        //  console.log('i am inn');
        this.processingPayment = true;
        data = JSON.parse(data.slice(10));
        const token = data.Token;
        let authData;
        //  console.log('token', token);
        this.payerInfoService.authProcessingPaymentUs(token, this.policyStore).subscribe(
          (response: any) => {
            authData = response;
            // this.processingPayment = false;
            if (response['payment-response']['payment-status'] == 'ACCEPTED') {
              const uid = response['payment-response']['reference-number'];

              this.savedPaymentMethodService.setSavedPaymentMethod({
                mplPolicyId: this.policyStore?.policyData?.policy?.policyId,
                paymentusResponse: data,
              });
              this.handleAuthorizedPaymentResponse(response, token);
            } else {
              // console.log('errorResponse',response);
              this.processingPayment = false;
              if (response['payment-response']['payment-status-description'] == null) {
                this.errors.push({
                  code: 'NA',
                  message: 'There was an unexpected error. Please contact Arch Service Center for support.',
                });
              } else {
                this.errors.push({
                  code: 'NA',
                  message: response['payment-response']['payment-status-description'],
                });
              }
            }
          },
          (errorResponse: any) => {
            console.log('errorResponse', errorResponse);
            this.processingPayment = false;
            this.errors.push({
              code: 'NA',
              message: 'There was an unexpected error. Please contact Arch Service Center for support.',
            });
          }
        );
      } else if (sender[0] == 'Result') {
        console.log('Error:', $event.data);
        //let errorMsg = JSON.parse(data.slice());
        this.errors.push({
          code: 'NA',
          message: 'There was an unexpected error. Please contact Arch Service Center for support.',
        });
        this.processingPayment = false;
      }
    }
    // else if ($event.data.subject == 'cancelPayment') {
    //   this.pendoService.track('cancelledPaymentButton', this.policyStore);
    //   this.router.navigate([
    //     `policy${this.policyStore.product == 'ea' ? '/' + this.policyStore.product : ''}/${
    //       this.policyStore.policyData.policy.policyId
    //     }`,
    //   ]);
    // }
    else {
      this.pendoService.track('unknownError', this.policyStore);
      console.log('unhandled post message subject', $event.data.subject, $event.data);
    }
  }
}
